export class SearchCondition {
  base_sheet_id: string = ""
  student_code: string = ""
  name: string = ""
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  grade: string = ""
  kumi: string = ""
  student_no: string = ""
  status: string = ""
  page: number = 1
  row_count: number =  100
}

export class Student {
  id: number
  student_code: number
  name: string
  course_code: number
  campus_code: number
  class_code: number
  course_name: string
  campus_name: string
  class_name: string
  email: string
  email_parent1: string
  email_parent2: string
  grade: number
  grade_name: string
  kumi: string
  student_no: number
  status: number
  full_count: number
  is_checked: boolean = false
  scoring_count: number
  failed_count: number
  passed_count: number
  submitted_count: number
  published_count: number
  report_count: number
  passed_percent: number
  submitted_percent: number


  constructor(student: any){
    this.id = student.id;
    this.student_code = student.student_code;
    this.name = student.name;
    this.course_code = student.course_code;
    this.campus_code = student.campus_code;
    this.class_code = student.class_code;
    this.course_name = student.course_name;
    this.campus_name = student.campus_name;
    this.class_name = student.class_name;
    this.email = student.email;
    this.email_parent1 = student.email_parent1;
    this.email_parent2 = student.email_parent2;
    this.grade = student.grade;
    this.grade_name = student.grade_name;
    this.kumi = student.kumi;
    this.student_no = student.student_no;
    this.status = student.status;
    this.full_count = student.full_count;
    this.scoring_count = student.scoring_count;
    this.failed_count = student.failed_count;
    this.passed_count = student.passed_count;
    this.submitted_count = student.submitted_count;
    this.published_count = student.published_count;
    this.report_count = student.report_count;
    this.submitted_percent = this.submitted_count == 0 || this.report_count == 0 ? 0 : Math.floor(this.submitted_count * 100 / this.report_count);
    this.passed_percent = student.total_passed_count == 0 || student.total_published_count == 0 ? 0 : Math.floor(student.total_passed_count * 100 / student.total_published_count);
  }
}